import React, { useState } from "react";
import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
} from "@mui/material";
import OddButton from "../../components/OddButton/OddButton";
import inpalyImg from "../../assets/images/sports/inplay.svg";
import moment from "moment";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { SportImgMap } from "../../constants/common-utlits";
import { connect } from "react-redux";
import { RootState } from "../../models/RootState";
import { addExchangeBet } from "../../store";
import { BsData } from "../../models/BsData";
import Betslip from "../../components/BetSlip/BetSlip";
import "./EventsTable.scss";

type TableProps = {
  events: any;
  bets: BsData[];
  addExchangeBet: (data) => void;
  operatorId: string;
};

const EventsTable: React.FC<TableProps> = (props) => {
  const { events, bets, addExchangeBet, operatorId } = props;
  const { provider, sportId } = useParams();
  const [selectedRow, setSelectedRow] = useState<string>("");
  let navigate = useNavigate();

  return (
    <div className="events-table-ctn">
      <TableContainer className="web-view">
        <Table
          aria-label="simple table"
          className="sport-events-tbl"
          size="small"
        >
          <TableHead>
            <TableRow>
              <TableCell colSpan={3}>
                {events && events?.length > 0 ? (
                  <div className="sport-name">
                    <img
                      className="sport-img"
                      alt={sportId}
                      src={SportImgMap[sportId]}
                    />{" "}
                    {"Events"}
                  </div>
                ) : null}
              </TableCell>
              <TableCell className="runner" align="center">
                1
              </TableCell>
              <TableCell className="runner" align="center">
                x
              </TableCell>
              <TableCell className="runner" align="center">
                2
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {events && events?.length > 0 ? (
              events.map((row, index) => (
                <>
                  <TableRow
                    key={row.eventName}
                    onClick={(data) => {
                      navigate(
                        `/lobby/${provider}/${row.sportId}/${row.eventId}/${row.competitionId}`
                      );
                    }}
                  >
                    <TableCell
                      align="left"
                      className="web-view"
                      component="th"
                      scope="row"
                      colSpan={2}
                    >
                      <NavLink
                        to={`/lobby/${provider}/${row.sportId}/${row.eventId}/${row.competitionId}`}
                        className="navlink"
                      >
                        <div className="event-name"> {row.eventName} </div>

                        <div className="date">
                          {operatorId === "MPC1"
                            ? moment(row.openDate).format("DD-MM-YYYY hh:mm A")
                            : moment(row.openDate).format(
                                "MMM DD YYYY hh:mm A"
                              )}
                        </div>
                      </NavLink>
                    </TableCell>
                    {/* <TableCell
                      align="left"
                      className="event-detail web-view"
                      component="th"
                      scope="row"
                    ></TableCell> */}
                    <TableCell>
                      {row.status === "IN_PLAY" ? (
                        <img src={inpalyImg} alt="live" />
                      ) : null}
                    </TableCell>

                    {row &&
                    row.markets &&
                    row.markets.matchOdds &&
                    row.markets.matchOdds[0] &&
                    row.markets.matchOdds[0].runners?.length ? (
                      row.markets.matchOdds[0].runners?.length === 1 ? (
                        <>
                          <TableCell align="right">
                            <OddButton
                              marketName="mo"
                              data={[
                                row.markets.matchOdds[0]?.runners[0].backPrices
                                  ?.length > 0
                                  ? row.markets.matchOdds[0].runners[0]
                                      .backPrices[0]
                                  : { price: 0, size: 0 },
                                row.markets.matchOdds[0].runners[0]?.layPrices
                                  ?.length > 0
                                  ? row.markets.matchOdds[0].runners[0]
                                      .layPrices[0]
                                  : { price: 0, size: 0 },
                              ]}
                              onClick={(data) => {
                                // if (row.status === "IN_PLAY")
                                //   addExchangeBet({
                                //     eventId: row.eventId,
                                //     eventName: row.eventName,
                                //     marketId: row?.marketId,
                                //     marketName: "Match Odds",
                                //     oddValue: data.oddValue,
                                //     betType: data.betType,
                                //     marketType: "MATCH_ODDS",
                                //     stakeAmount: 0,
                                //     runnerId:
                                //       row.markets.matchOdds[0].runners[0]
                                //         .runnerId,
                                //     runnerName:
                                //       row.markets.matchOdds[0].runners[0]
                                //         .runnerName,
                                //     competitionId: row.competitionId,
                                //     sportId: row.sportId,
                                //     minLimit: row.markets.matchOdds[0]?.limits
                                //       ?.minBetValue
                                //       ? row.markets.matchOdds[0]?.limits
                                //           ?.minBetValue
                                //       : 0,
                                //     maxLimit: row.markets.matchOdds[0]?.limits
                                //       ?.maxBetValue
                                //       ? row.markets.matchOdds[0]?.limits
                                //           ?.maxBetValue
                                //       : 0,
                                //   });
                                // setSelectedRow(index + row?.eventId + "MO");
                              }}
                            />
                          </TableCell>
                          <TableCell align="right">
                            <OddButton
                              marketName="mo"
                              data={[
                                { price: 0, size: 0 },
                                { price: 0, size: 0 },
                              ]}
                              onClick={(data) => {}}
                            />
                          </TableCell>
                          <TableCell align="right">
                            <OddButton
                              marketName="mo"
                              data={[
                                { price: 0, size: 0 },
                                { price: 0, size: 0 },
                              ]}
                              onClick={(data) => {}}
                            />
                          </TableCell>
                        </>
                      ) : row.markets.matchOdds[0].runners?.length === 2 ? (
                        <>
                          <TableCell align="right">
                            <OddButton
                              marketName="mo"
                              data={[
                                row.markets.matchOdds[0].runners[0].backPrices
                                  ?.length > 0
                                  ? row.markets.matchOdds[0].runners[0]
                                      .backPrices[0]
                                  : { price: 0, size: 0 },
                                row.markets.matchOdds[0].runners[0].layPrices
                                  ?.length > 0
                                  ? row.markets.matchOdds[0].runners[0]
                                      .layPrices[0]
                                  : { price: 0, size: 0 },
                              ]}
                              onClick={(data) => {
                                //   if (row.status === "IN_PLAY")
                                //     addExchangeBet({
                                //       eventId: row.eventId,
                                //       eventName: row.eventName,
                                //       marketId: row?.marketId,
                                //       marketName: "Match Odds",
                                //       oddValue: data.oddValue,
                                //       betType: data.betType,
                                //       marketType: "MATCH_ODDS",
                                //       stakeAmount: 0,
                                //       runnerId:
                                //         row.markets.matchOdds[0].runners[0]
                                //           .runnerId,
                                //       runnerName:
                                //         row.markets.matchOdds[0].runners[0]
                                //           .runnerName,
                                //       competitionId: row.competitionId,
                                //       sportId: row.sportId,
                                //       minLimit: row.markets.matchOdds[0]?.limits
                                //         ?.minBetValue
                                //         ? row.markets.matchOdds[0]?.limits
                                //             ?.minBetValue
                                //         : 0,
                                //       maxLimit: row.markets.matchOdds[0]?.limits
                                //         ?.maxBetValue
                                //         ? row.markets.matchOdds[0]?.limits
                                //             ?.maxBetValue
                                //         : 0,
                                //     });
                                //   setSelectedRow(index + row?.eventId + "MO");
                              }}
                            />
                          </TableCell>
                          <TableCell align="right">
                            <OddButton
                              marketName="mo"
                              data={[
                                { price: 0, size: 0 },
                                { price: 0, size: 0 },
                              ]}
                              onClick={(data) => {}}
                            />
                          </TableCell>
                          <TableCell align="right">
                            <OddButton
                              marketName="mo"
                              data={[
                                row.markets.matchOdds[0].runners[1].backPrices
                                  ?.length > 0
                                  ? row.markets.matchOdds[0].runners[1]
                                      .backPrices[0]
                                  : { price: 0, size: 0 },
                                row.markets.matchOdds[0].runners[1].layPrices
                                  ?.length > 0
                                  ? row.markets.matchOdds[0].runners[1]
                                      .layPrices[0]
                                  : { price: 0, size: 0 },
                              ]}
                              onClick={(data) => {
                                // if (row.status === "IN_PLAY")
                                //   addExchangeBet({
                                //     eventId: row.eventId,
                                //     eventName: row.eventName,
                                //     marketId: row?.marketId,
                                //     marketName: "Match Odds",
                                //     oddValue: data.oddValue,
                                //     betType: data.betType,
                                //     marketType: "MATCH_ODDS",
                                //     stakeAmount: 0,
                                //     runnerId:
                                //       row.markets.matchOdds[0].runners[1]
                                //         .runnerId,
                                //     runnerName:
                                //       row.markets.matchOdds[0].runners[1]
                                //         .runnerName,
                                //     competitionId: row.competitionId,
                                //     sportId: row.sportId,
                                //     minLimit: row.markets.matchOdds[0]?.limits
                                //       ?.minBetValue
                                //       ? row.markets.matchOdds[0]?.limits
                                //           ?.minBetValue
                                //       : 0,
                                //     maxLimit: row.markets.matchOdds[0]?.limits
                                //       ?.maxBetValue
                                //       ? row.markets.matchOdds[0]?.limits
                                //           ?.maxBetValue
                                //       : 0,
                                //   });
                                // setSelectedRow(index + row?.eventId + "MO");
                              }}
                            />
                          </TableCell>
                        </>
                      ) : (
                        <>
                          <TableCell align="right">
                            <OddButton
                              marketName="mo"
                              data={[
                                row.markets.matchOdds[0].runners[0].backPrices
                                  ?.length > 0
                                  ? row.markets.matchOdds[0].runners[0]
                                      .backPrices[0]
                                  : { price: 0, size: 0 },
                                row.markets.matchOdds[0].runners[0].layPrices
                                  ?.length > 0
                                  ? row.markets.matchOdds[0].runners[0]
                                      .layPrices[0]
                                  : { price: 0, size: 0 },
                              ]}
                              onClick={(data) => {
                                // if (row.status === "IN_PLAY")
                                //   addExchangeBet({
                                //     eventId: row.eventId,
                                //     eventName: row.eventName,
                                //     marketId: row?.marketId,
                                //     marketName: "Match Odds",
                                //     oddValue: data.oddValue,
                                //     betType: data.betType,
                                //     marketType: "MATCH_ODDS",
                                //     stakeAmount: 0,
                                //     runnerId:
                                //       row.markets.matchOdds[0].runners[1]
                                //         .runnerId,
                                //     runnerName:
                                //       row.markets.matchOdds[0].runners[1]
                                //         .runnerName,
                                //     competitionId: row.competitionId,
                                //     sportId: row.sportId,
                                //     minLimit: row.markets.matchOdds[0]?.limits
                                //       ?.minBetValue
                                //       ? row.markets.matchOdds[0]?.limits
                                //           ?.minBetValue
                                //       : 0,
                                //     maxLimit: row.markets.matchOdds[0]?.limits
                                //       ?.maxBetValue
                                //       ? row.markets.matchOdds[0]?.limits
                                //           ?.maxBetValue
                                //       : 0,
                                //   });
                                // setSelectedRow(index + row?.eventId + "MO");
                              }}
                            />
                          </TableCell>

                          <TableCell align="right">
                            <OddButton
                              marketName="mo"
                              data={[
                                row.markets.matchOdds[0].runners[2].backPrices
                                  ?.length > 0
                                  ? row.markets.matchOdds[0].runners[2]
                                      .backPrices[0]
                                  : { price: 0, size: 0 },
                                row.markets.matchOdds[0].runners[2].layPrices
                                  ?.length > 0
                                  ? row.markets.matchOdds[0].runners[2]
                                      .layPrices[0]
                                  : { price: 0, size: 0 },
                              ]}
                              onClick={(data) => {
                                // if (row.status === "IN_PLAY")
                                //   addExchangeBet({
                                //     eventId: row.eventId,
                                //     eventName: row.eventName,
                                //     marketId: row?.marketId,
                                //     marketName: "Match Odds",
                                //     oddValue: data.oddValue,
                                //     betType: data.betType,
                                //     marketType: "MATCH_ODDS",
                                //     stakeAmount: 0,
                                //     runnerId:
                                //       row.markets.matchOdds[0].runners[2]
                                //         .runnerId,
                                //     runnerName:
                                //       row.markets.matchOdds[0].runners[2]
                                //         .runnerName,
                                //     competitionId: row.competitionId,
                                //     sportId: row.sportId,
                                //     minLimit: row.markets.matchOdds[0]?.limits
                                //       ?.minBetValue
                                //       ? row.markets.matchOdds[0]?.limits
                                //           ?.minBetValue
                                //       : 0,
                                //     maxLimit: row.markets.matchOdds[0]?.limits
                                //       ?.maxBetValue
                                //       ? row.markets.matchOdds[0]?.limits
                                //           ?.maxBetValue
                                //       : 0,
                                //   });
                                // setSelectedRow(index + row?.eventId + "MO");
                              }}
                            />
                          </TableCell>
                          <TableCell align="right">
                            <OddButton
                              marketName="mo"
                              data={[
                                row.markets.matchOdds[0].runners[1].backPrices
                                  ?.length > 0
                                  ? row.markets.matchOdds[0].runners[1]
                                      .backPrices[0]
                                  : { price: 0, size: 0 },
                                row.markets.matchOdds[0].runners[1].layPrices
                                  ?.length > 0
                                  ? row.markets.matchOdds[0].runners[1]
                                      .layPrices[0]
                                  : { price: 0, size: 0 },
                              ]}
                              onClick={(data) => {
                                // if (row.status === "IN_PLAY")
                                //   addExchangeBet({
                                //     eventId: row.eventId,
                                //     eventName: row.eventName,
                                //     marketId: row?.marketId,
                                //     marketName: "Match Odds",
                                //     oddValue: data.oddValue,
                                //     betType: data.betType,
                                //     marketType: "MATCH_ODDS",
                                //     stakeAmount: 0,
                                //     runnerId:
                                //       row.markets.matchOdds[0].runners[1]
                                //         .runnerId,
                                //     runnerName:
                                //       row.markets.matchOdds[0].runners[1]
                                //         .runnerName,
                                //     competitionId: row.competitionId,
                                //     sportId: row.sportId,
                                //     minLimit: row.markets.matchOdds[0]?.limits
                                //       ?.minBetValue
                                //       ? row.markets.matchOdds[0]?.limits
                                //           ?.minBetValue
                                //       : 0,
                                //     maxLimit: row.markets.matchOdds[0]?.limits
                                //       ?.maxBetValue
                                //       ? row.markets.matchOdds[0]?.limits
                                //           ?.maxBetValue
                                //       : 0,
                                //   });
                                // setSelectedRow(index + row?.eventId + "MO");
                              }}
                            />
                          </TableCell>
                        </>
                      )
                    ) : null}
                  </TableRow>
                </>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5}>Not Found</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <div className="mob-view event-table-mob-view">
        <TableContainer className="event-table-mob-container">
          <Table
            aria-label="simple table"
            size="small"
            className="event-table-mob"
          >
            <TableBody className="event-table-mob-body">
              {events && events?.length > 0 ? (
                events.map((row, index) => (
                  <>
                    <TableRow
                      key={row.eventName}
                      onClick={(data) => {
                        navigate(
                          `/lobby/${provider}/${row.sportId}/${row.eventId}/${row.competitionId}`
                        );
                      }}
                    >
                      <TableCell
                        align="left"
                        className="event-detail-mob"
                        scope="row"
                      >
                        <div className="mob-event-name">
                          <NavLink
                            to={`/lobby/${provider}/${row.sportId}/${row.eventId}/${row.competitionId}`}
                            className="navlink"
                          >
                            {" "}
                            <div className="eventname"> {row.eventName}</div>
                            <div className="inplay-icon">
                              {row.status === "IN_PLAY" ? (
                                <img
                                  src={inpalyImg}
                                  alt="live"
                                  height="15"
                                  width="15"
                                />
                              ) : null}
                            </div>
                          </NavLink>

                          <div className="date">
                            {" "}
                            {row &&
                              row.openDate &&
                              moment(row.openDate).format(
                                "MMM DD YYYY hh:mm A"
                              )}
                          </div>
                        </div>
                        <div className="event-table-odds-ctn">
                          {row &&
                          row.markets &&
                          row.markets.matchOdds &&
                          row.markets.matchOdds[0] &&
                          row.markets.matchOdds[0]?.runners?.length ? (
                            row.markets.matchOdds[0].runners?.length === 1 ? (
                              <>
                                <div className="event-table-odds-row">
                                  <OddButton
                                    marketName="mo"
                                    data={[
                                      row.markets.matchOdds[0].runners[0]
                                        .backPrices?.length > 0
                                        ? row.markets.matchOdds[0].runners[0]
                                            .backPrices[0]
                                        : { price: 0, size: 0 },
                                      row.markets.matchOdds[0].runners[0]
                                        .layPrices?.length > 0
                                        ? row.markets.matchOdds[0].runners[0]
                                            .layPrices[0]
                                        : { price: 0, size: 0 },
                                    ]}
                                    onClick={(data) => {
                                      // if (row.status === "IN_PLAY")
                                      //   addExchangeBet({
                                      //     eventId: row.eventId,
                                      //     eventName: row.eventName,
                                      //     marketId: row?.marketId,
                                      //     marketName: "Match Odds",
                                      //     oddValue: data.oddValue,
                                      //     betType: data.betType,
                                      //     marketType: "MATCH_ODDS",
                                      //     stakeAmount: 0,
                                      //     runnerId:
                                      //       row.markets.matchOdds[0].runners[0]
                                      //         .runnerId,
                                      //     runnerName:
                                      //       row.markets.matchOdds[0].runners[0]
                                      //         .runnerName,
                                      //     competitionId: row.competitionId,
                                      //     sportId: row.sportId,
                                      //     minLimit: row.markets.matchOdds[0]
                                      //       ?.limits?.minBetValue
                                      //       ? row.markets.matchOdds[0]?.limits
                                      //           ?.minBetValue
                                      //       : 0,
                                      //     maxLimit: row.markets.matchOdds[0]
                                      //       ?.limits?.maxBetValue
                                      //       ? row.markets.matchOdds[0]?.limits
                                      //           ?.maxBetValue
                                      //       : 0,
                                      //   });
                                      // setSelectedRow(
                                      //   index + row?.eventId + "MO"
                                      // );
                                    }}
                                  />
                                  <OddButton
                                    marketName="mo"
                                    data={[
                                      { price: 0, size: 0 },
                                      { price: 0, size: 0 },
                                    ]}
                                    onClick={(data) => {}}
                                  />
                                  <OddButton
                                    marketName="mo"
                                    data={[
                                      { price: 0, size: 0 },
                                      { price: 0, size: 0 },
                                    ]}
                                    onClick={(data) => {}}
                                  />
                                </div>
                              </>
                            ) : row.markets.matchOdds[0].runners?.length ===
                              2 ? (
                              <>
                                <div className="event-table-odds-row">
                                  <OddButton
                                    marketName="mo"
                                    data={[
                                      row.markets.matchOdds[0].runners[0]
                                        .backPrices?.length
                                        ? row.markets.matchOdds[0].runners[0]
                                            .backPrices[0]
                                        : { price: 0, size: 0 },
                                      row.markets.matchOdds[0].runners[0]
                                        .layPrices?.length
                                        ? row.markets.matchOdds[0].runners[0]
                                            .layPrices[0]
                                        : { price: 0, size: 0 },
                                    ]}
                                    onClick={(data) => {
                                      // if (row.status === "IN_PLAY")
                                      //   addExchangeBet({
                                      //     eventId: row.eventId,
                                      //     eventName: row.eventName,
                                      //     marketId: row?.marketId,
                                      //     marketName: "Match Odds",
                                      //     oddValue: data.oddValue,
                                      //     betType: data.betType,
                                      //     marketType: "MATCH_ODDS",
                                      //     stakeAmount: 0,
                                      //     runnerId:
                                      //       row.markets.matchOdds[0].runners[0]
                                      //         .runnerId,
                                      //     runnerName:
                                      //       row.markets.matchOdds[0].runners[0]
                                      //         .runnerName,
                                      //     competitionId: row.competitionId,
                                      //     sportId: row.sportId,
                                      //     minLimit: row.markets.matchOdds[0]
                                      //       ?.limits?.minBetValue
                                      //       ? row.markets.matchOdds[0]?.limits
                                      //           ?.minBetValue
                                      //       : 0,
                                      //     maxLimit: row.markets.matchOdds[0]
                                      //       ?.limits?.maxBetValue
                                      //       ? row.markets.matchOdds[0]?.limits
                                      //           ?.maxBetValue
                                      //       : 0,
                                      //   });
                                      // setSelectedRow(
                                      //   index + row?.eventId + "MO"
                                      // );
                                    }}
                                  />
                                  <OddButton
                                    marketName="mo"
                                    data={[
                                      { price: 0, size: 0 },
                                      { price: 0, size: 0 },
                                    ]}
                                    onClick={(data) => {}}
                                  />
                                  <OddButton
                                    marketName="mo"
                                    data={[
                                      row.markets.matchOdds[0].runners[1]
                                        .backPrices?.length
                                        ? row.markets.matchOdds[0].runners[1]
                                            .backPrices[0]
                                        : { price: 0, size: 0 },
                                      row.markets.matchOdds[0].runners[1]
                                        .layPrices?.length
                                        ? row.markets.matchOdds[0].runners[1]
                                            .layPrices[0]
                                        : { price: 0, size: 0 },
                                    ]}
                                    onClick={(data) => {
                                      // if (row.status === "IN_PLAY")
                                      //   addExchangeBet({
                                      //     eventId: row.eventId,
                                      //     eventName: row.eventName,
                                      //     marketId: row?.marketId,
                                      //     marketName: "Match Odds",
                                      //     oddValue: data.oddValue,
                                      //     betType: data.betType,
                                      //     marketType: "MATCH_ODDS",
                                      //     stakeAmount: 0,
                                      //     runnerId:
                                      //       row.markets.matchOdds[0].runners[1]
                                      //         .runnerId,
                                      //     runnerName:
                                      //       row.markets.matchOdds[0].runners[1]
                                      //         .runnerName,
                                      //     competitionId: row.competitionId,
                                      //     sportId: row.sportId,
                                      //     minLimit: row.markets.matchOdds[0]
                                      //       ?.limits?.minBetValue
                                      //       ? row.markets.matchOdds[0]?.limits
                                      //           ?.minBetValue
                                      //       : 0,
                                      //     maxLimit: row.markets.matchOdds[0]
                                      //       ?.limits?.maxBetValue
                                      //       ? row.markets.matchOdds[0]?.limits
                                      //           ?.maxBetValue
                                      //       : 0,
                                      //   });
                                      // setSelectedRow(
                                      //   index + row?.eventId + "MO"
                                      // );
                                    }}
                                  />
                                </div>
                              </>
                            ) : (
                              <div className="event-table-odds-row">
                                <OddButton
                                  marketName="mo"
                                  data={[
                                    row.markets.matchOdds[0].runners[0]
                                      .backPrices?.length
                                      ? row.markets.matchOdds[0].runners[0]
                                          .backPrices[0]
                                      : { price: 0, size: 0 },
                                    row.markets.matchOdds[0].runners[0]
                                      .layPrices?.length
                                      ? row.markets.matchOdds[0].runners[0]
                                          .layPrices[0]
                                      : { price: 0, size: 0 },
                                  ]}
                                  onClick={(data) => {
                                    // if (row.status === "IN_PLAY")
                                    //   addExchangeBet({
                                    //     eventId: row.eventId,
                                    //     eventName: row.eventName,
                                    //     marketId: row?.marketId,
                                    //     marketName: "Match Odds",
                                    //     oddValue: data.oddValue,
                                    //     betType: data.betType,
                                    //     marketType: "MATCH_ODDS",
                                    //     stakeAmount: 0,
                                    //     runnerId:
                                    //       row.markets.matchOdds[0].runners[0]
                                    //         .runnerId,
                                    //     runnerName:
                                    //       row.markets.matchOdds[0].runners[0]
                                    //         .runnerName,
                                    //     competitionId: row.competitionId,
                                    //     sportId: row.sportId,
                                    //     minLimit: row.markets.matchOdds[0]
                                    //       ?.limits?.minBetValue
                                    //       ? row.markets.matchOdds[0]?.limits
                                    //           ?.minBetValue
                                    //       : 0,
                                    //     maxLimit: row.markets.matchOdds[0]
                                    //       ?.limits?.maxBetValue
                                    //       ? row.markets.matchOdds[0]?.limits
                                    //           ?.maxBetValue
                                    //       : 0,
                                    //   });
                                    // setSelectedRow(index + row?.eventId + "MO");
                                  }}
                                />
                                <OddButton
                                  marketName="mo"
                                  data={[
                                    row.markets.matchOdds[0].runners[2]
                                      .backPrices?.length
                                      ? row.markets.matchOdds[0].runners[2]
                                          .backPrices[0]
                                      : { price: 0, size: 0 },
                                    row.markets.matchOdds[0].runners[2]
                                      .layPrices?.length
                                      ? row.markets.matchOdds[0].runners[2]
                                          .layPrices[0]
                                      : { price: 0, size: 0 },
                                  ]}
                                  onClick={(data) => {
                                    // if (row.status === "IN_PLAY")
                                    //   addExchangeBet({
                                    //     eventId: row.eventId,
                                    //     eventName: row.eventName,
                                    //     marketId: row?.marketId,
                                    //     marketName: "Match Odds",
                                    //     oddValue: data.oddValue,
                                    //     betType: data.betType,
                                    //     marketType: "MATCH_ODDS",
                                    //     stakeAmount: 0,
                                    //     runnerId:
                                    //       row.markets.matchOdds[0].runners[2]
                                    //         .runnerId,
                                    //     runnerName:
                                    //       row.markets.matchOdds[0].runners[2]
                                    //         .runnerName,
                                    //     competitionId: row.competitionId,
                                    //     sportId: row.sportId,
                                    //     minLimit: row.markets.matchOdds[0]
                                    //       ?.limits?.minBetValue
                                    //       ? row.markets.matchOdds[0]?.limits
                                    //           ?.minBetValue
                                    //       : 0,
                                    //     maxLimit: row.markets.matchOdds[0]
                                    //       ?.limits?.maxBetValue
                                    //       ? row.markets.matchOdds[0]?.limits
                                    //           ?.maxBetValue
                                    //       : 0,
                                    //   });
                                    // setSelectedRow(index + row?.eventId + "MO");
                                  }}
                                />
                                <OddButton
                                  marketName="mo"
                                  data={[
                                    row.markets.matchOdds[0].runners[1]
                                      .backPrices?.length
                                      ? row.markets.matchOdds[0].runners[1]
                                          .backPrices[0]
                                      : { price: 0, size: 0 },
                                    row.markets.matchOdds[0].runners[1]
                                      .layPrices?.length
                                      ? row.markets.matchOdds[0].runners[1]
                                          .layPrices[0]
                                      : { price: 0, size: 0 },
                                  ]}
                                  onClick={(data) => {
                                    // if (row.status === "IN_PLAY")
                                    //   addExchangeBet({
                                    //     eventId: row.eventId,
                                    //     eventName: row.eventName,
                                    //     marketId: row?.marketId,
                                    //     marketName: "Match Odds",
                                    //     oddValue: data.oddValue,
                                    //     betType: data.betType,
                                    //     marketType: "MATCH_ODDS",
                                    //     stakeAmount: 0,
                                    //     runnerId:
                                    //       row.markets.matchOdds[0].runners[1]
                                    //         .runnerId,
                                    //     runnerName:
                                    //       row.markets.matchOdds[0].runners[1]
                                    //         .runnerName,
                                    //     competitionId: row.competitionId,
                                    //     sportId: row.sportId,
                                    //     minLimit: row.markets.matchOdds[0]
                                    //       ?.limits?.minBetValue
                                    //       ? row.markets.matchOdds[0]?.limits
                                    //           ?.minBetValue
                                    //       : 0,
                                    //     maxLimit: row.markets.matchOdds[0]
                                    //       ?.limits?.maxBetValue
                                    //       ? row.markets.matchOdds[0]?.limits
                                    //           ?.maxBetValue
                                    //       : 0,
                                    //   });
                                    // setSelectedRow(index + row?.eventId + "MO");
                                  }}
                                />
                              </div>
                            )
                          ) : null}
                        </div>
                      </TableCell>
                    </TableRow>

                    {bets?.length > 0 &&
                    selectedRow === index + bets[0].eventId + "MO" ? (
                      <TableRow className="bet-slip-row mob-view">
                        <TableCell>
                          {" "}
                          <Betslip page={"market"} />{" "}
                        </TableCell>
                      </TableRow>
                    ) : null}
                  </>
                ))
              ) : (
                <TableRow>
                  <TableCell>Not Found</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    operatorId: state.auth.operatorId,
    loggedIn: state.auth.loggedIn,
    bets: state.betslip.bets,
    openBetsData: state.betslip.openBets,
    eventInfo: state.sportsBook.eventInfo,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    addExchangeBet: (data: BsData) => dispatch(addExchangeBet(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EventsTable);
